// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLazyload from 'vue-lazyload'
import SoundcloudWidget from 'soundcloud-widget'
import _ from 'underscore'
import Tracklist from '@/Tracklist.js'
import Exhibit from '@/Exhibit.js'

Vue.config.productionTip = false

Vue.use(VueLazyload, {
  lazyComponent: true,
  listenEvents: [ 'scroll' ]
})

// Dummy Soundcloud API until
// the widget has actually loaded

var dummyAPI = {
  skip: function () {},
  toggle: function () {},
  setVolume: function () {},
  seekTo: function () {},
  pause: function () {},
  play: function () {},
  prev: function () {},
  next: function () {},
  isPaused: function () {},
  getDuration: function () {
    return new Promise((resolve, reject) => {})
  }
}

var soundcloud = {
  api: dummyAPI,
  ready: false,
  playing: false,
  progress: 0
}

var app = new Vue({ // eslint-disable-line no-new
  el: '#app',
  router,
  data: {
    soundcloud: soundcloud,
    tracklist: Tracklist,
    exhibit: Exhibit
  },
  template: '<App v-bind:soundcloud="soundcloud" v-bind:tracklist="tracklist" v-bind:exhibit="exhibit"/>',
  components: { App }
})

function initializeSoundcloud () {
  var soundcloudSnippet = document.createElement('iframe')
  soundcloudSnippet.id = 'soundcloud'
  soundcloudSnippet.width = '100%'
  soundcloudSnippet.height = '300'
  soundcloudSnippet.scrolling = 'no'
  soundcloudSnippet.frameborder = 'no'
  soundcloudSnippet.src = 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/352947262%3Fsecret_token%3Ds-viIN5&amp;color=ffffff&amp;auto_play=false&amp;hide_related=true&amp;show_comments=false&amp;show_user=false&amp;show_reposts=false&amp;visual=false'
  document.body.appendChild(soundcloudSnippet)

  var soundcloudAPI = new SoundcloudWidget(
    document.querySelector('iframe')
  )

  soundcloudAPI.bind(SoundcloudWidget.events.PLAY_PROGRESS, function (progress) {
    Vue.set(soundcloud, 'progress', progress)
  })

  soundcloudAPI.bind(SoundcloudWidget.events.PLAY, function () {
    app.soundcloud.playing = true
    soundcloudAPI.getCurrentSound().then(function (sound) {
      _.each(app.tracklist, function (track) {
        if (track.soundcloud_id === sound.id) {
          track.playing = true
        } else {
          track.playing = false
        }
      })
    })
  })

  soundcloudAPI.bind(SoundcloudWidget.events.PAUSE, function (progress) {
    app.soundcloud.playing = false
    if (progress.relativePosition > 0.999) {
      // If we are pausing because it is the end
      // of the track, seek to zero.
      // console.log('End of track. Do not seek.')
      soundcloudAPI.setVolume(0)
      soundcloudAPI.seekTo(0)
      var currentTrack = _.findWhere(app.tracklist, {playing: true})
      soundcloudAPI.skip(currentTrack.track_number)
      soundcloudAPI.pause()
      soundcloudAPI.setVolume(100)
    } else {
      // If we are pausing for any other reason,
      // signal that we are
      _.each(app.tracklist, function (track) {
        track.playing = false
      })
    }
  })

  soundcloudAPI.bind(SoundcloudWidget.events.READY, function () {
    app.soundcloud.ready = true
  })

  app.soundcloud.api = soundcloudAPI
}

initializeSoundcloud()



// WEBPACK FOOTER //
// ./src/main.js